import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useAdAccountRenameRequestStore = defineStore({
  id: 'adAccountRenameRequest',
  actions: {
    async createAdAccountRenameRequest(payload) {
      const {data} = await axios.post('ad-account-rename-requests', payload)

      return data
    },

    async getAdAccountRenameRequests(params = {}) {
      const {data} = await axios.get('ad-account-rename-requests', {params})

      return data
    },
  },
})
